(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('InvoiceMinDTOCustomService', InvoiceMinDTOCustomService);

    InvoiceMinDTOCustomService.$inject = ['$http'];

    function InvoiceMinDTOCustomService($http) {
        return {
            updateInvoiceStatus: updateInvoiceStatus
        }

        function updateInvoiceStatus(invoices, status) {
            var url = "api/invoiceMinDTO/status/" + status;
            return $http({
                url: url,
                method: 'POST',
                data: invoices,
                headers: {'Content-Type':'application/json'}
            });
        }
    }
})();
